import React from "react";
import "tailwindcss/tailwind.css";
import "../Example/Example.css"; 
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../Tool/Tool.css'; 
import '../Home/Home.css';

const tableData_pt = [
  {
    categoria: "VISÃO",
    n0: "Ausência de visão sobre a circularidade urbana.",
    n1: "Circularidade associada à gestão de resíduos; foco em reciclagem e recuperação.",
    n2: "Circularidade associada a Economia Circular urbana, foco em criação de um ambiente de inovação e modelos de negócios circulares.",
    n3: "Visão sistêmica e de longo prazo; integração sistêmica de ações circulares, regenerativas, adaptativas e transformação dos padrões de produção e consumo e de localização; alinhamento com sustentabilidade (aspectos ambientais, sociais e econômicos)."
  },
  {
    categoria: "GOVERNANÇA E ATORES",
    n0: "Governança inexistente para circularidade urbana.",
    n1: "Governança voltada à gestão de resíduos; participação limitada de atores. Financiamento para melhorias na gestão de resíduos e monitoramento do setor.",
    n2: "Governança parcialmente integrada; participação de múltiplos atores, com foco em inovação e ecossistemas circulares (setor privados, centros de pesquisa, universidades). Financiamento para empresas e monitoramento dos ganhos econômicos.",
    n3: "Governança colaborativa e multinível; forte articulação entre atores e participação ativa da população; integração entre setores e níveis institucionais. Estrutura de monitoramento robusta e formas de financiamento estabelecidas."
  },
  {
    categoria: "CICLO MATERIAL",
    n0: "Fluxos lineares (extração, consumo e descarte).",
    n1: "Foco em reciclagem e recuperação energética; fechamento parcial de ciclos.",
    n2: "Ampliação de práticas circulares (reutilização, reparo, remanufatura, reaproveitamento) promovidas por meio de modelos de negócios circulares.",
    n3: "Gestão integrada de materiais; priorização de recusar, repensar e reduzir; fechamento de ciclos com alto valor circular. Mudança no padrão de consumo."
  },
  {
    categoria: "CICLO BIOLÓGICO E HÍDRICO",
    n0: "Fluxos lineares (extração, consumo e descarte).",
    n1: "Iniciativas de produção de biogás a partir de resíduos orgânicos e ações pontuais de compostagem. Tratamento de água e esgoto.",
    n2: "Implementação de práticas circulares (reúso de água, compostagem atrelada a agricultura, recuperação de nutrientes de esgoto, redução dos resíduos alimentares) promovidas por meio de modelos de negócios circulares.",
    n3: "Integração sistêmica dos ciclos biológicos; soluções regenerativas (águas e dos ecossistemas), agricultura local com aproveitamento do espaço urbano."
  },
  {
    categoria: "ESPAÇO E AMBIENTE CONSTRUÍDO",
    n0: "Fluxos lineares (extração, consumo e descarte).",
    n1: "Preocupação inicial com resíduos de construção e demolição; adoção de práticas básicas de gestão e destinação adequada. Infraestrutura para gestão de resíduos.",
    n2: "Planejamento do ambiente construído para ecossistemas circulares; estímulo à produção local e simbiose industrial; valorização do estoque de materiais (reutilização, demolição seletiva, reaproveitamento e construções modulares).",
    n3: "Planejamento sistêmico do ambiente construído; regeneração de áreas verdes; integração entre sistemas naturais e urbanos; valorização do estoque construído (otimização e redução de ociosidade); infraestrutura com acesso equitativo e proximidade aos serviços."
  },
  {
    categoria: "EQUIDADE E JUSTIÇA SOCIAL",
    n0: "Distribuição desigual de recursos, serviços e infraestrutura.",
    n1: "Maior equidade no acesso aos serviços de gestão de resíduos; inclusão inicial de catadores informais.",
    n2: "Incorporação de práticas solidárias (doação, redistribuição e produtos a baixo custo); modelos de negócios circulares promovem geração de emprego e renda.",
    n3: "Justiça social integrada à circularidade; redistribuição do acesso a recursos, espaço urbano e serviços; redução do consumo e das desigualdades socioespaciais; promoção de suficiência, economia solidária e compartilhamento."
  }
];

const tableData_en = [
  {
    categoria: "VISION",
    n0: "Absence of a vision for urban circularity.",
    n1: "Circularity associated with waste management, focusing on recycling and recovery.",
    n2: "Circularity associated with the urban circular economy, focusing on fostering innovation and circular business models.",
    n3: "Systemic and long-term vision; integrated implementation of circular, regenerative, and adaptive actions; transformation of production, consumption, and localization patterns; and alignment with sustainability across environmental, social, and economic dimensions."
  },
  {
    categoria: "GOVERNANCE AND ACTORS",
    n0: "Absence of governance for urban circularity.",
    n1: "Governance focused on waste management, with limited actor participation. Financing is directed toward improvements in waste management and monitoring of the waste sector.",
    n2: "Partially integrated governance, involving multiple actors with a focus on innovation and circular ecosystems (private sector, research centers, universities). Financing is directed toward businesses and monitoring economic gains.",
    n3: "Collaborative and multilevel governance, with strong coordination among actors and active public participation, and integration across sectors and institutional levels. Robust monitoring structures and established financing mechanisms support implementation."
  },
  {
    categoria: "MATERIAL CYCLE",
    n0: "Linear flows (extraction, consumption, and disposal).",
    n1: "Focus on recycling and energy recovery, with partial closing of material loops.",
    n2: "Expansion of circular practices (reuse, repair, remanufacturing, and repurposing) promoted through circular business models.",
    n3: "Integrated material management, with a focus on refuse, rethink, and reduce; closing material loops with high circular value, and promoting a shift in consumption patterns."
  },
  {
    categoria: "BIOLOGICAL AND WATER CYCLE",
    n0: "Linear flows (extraction, consumption, and disposal).",
    n1: "Initiatives for biogas production from organic waste and standalone composting actions, along with water and wastewater treatment.",
    n2: "Implementation of circular practices (water reuse, composting linked to agriculture, nutrient recovery from wastewater, and reduction of food waste) promoted through circular business models.",
    n3: "Systemic integration of biological cycles, with regenerative solutions for water systems and ecosystems, and promotion of local agriculture utilizing urban spaces."
  },
  {
    categoria: "SPACE AND BUILT ENVIRONMENT",
    n0: "Linear flows (extraction, consumption, and disposal).",
    n1: "Initial concern with construction and demolition waste; adoption of basic management practices and proper disposal. Infrastructure for waste management.",
    n2: "Social justice integrated into circularity; redistribution of access to resources, urban space, and services; reduction of consumption and socio-spatial inequalities; promotion of sufficiency, solidarity economy, and sharing.",
    n3: "Systemic planning of the built environment; regeneration of green areas; integration between natural and urban systems; valorization of the built stock (optimization and reduction of vacancy); infrastructure with equitable access and proximity to services."
  },
  {
    categoria: "EQUITY AND SOCIAL JUSTICE",
    n0: "Unequal distribution of resources, services, and infrastructure.",
    n1: "Greater equity in access to waste management services, with the initial inclusion of informal waste pickers.",
    n2: "Incorporation of solidarity-based practices (donation, redistribution, and low-cost products) with circular business models promoting job creation and income generation.",
    n3: "Social justice integrated into circularity; redistribution of access to resources, urban space, and services; reduction of consumption and socio-spatial inequalities; promotion of sufficiency, solidarity economy, and sharing."
  }
];

const Exemplo = () => {
  const { t, i18n } = useTranslation();

  // Verifica se o idioma atual é inglês (ou começa com 'en')
  const isEn = i18n.language?.startsWith('en');

  // Seleciona o array de dados correto
  const activeData = isEn ? tableData_en : tableData_pt;

  const isAuthenticated = localStorage.getItem("token") !== null;
  return (
    <>
      <div className='text-container'>
          <h3 className='title-home'>{t('comp1-title')}</h3>
          <p>{t('comp1-text-1')}</p>
          <h3 className='title-home'>{t('comp1-title-2')}</h3>
          <p>{t('comp1-text-2')}</p>
          <p>{t('comp1-text-3')}</p>
          <p>{t('comp1-text-4')}</p>
          <p>{t('comp1-text-5')}</p>
      </div>

      <div className="table-container">
        <div className="container">
          <table className="custom-table">
            <thead>
              <tr>
                <th className="font-bold text-center"></th>
                <th className="nivel-6">
                  {isEn ? "Level 0 - LINEAR CITY" : "Nível 0 - CIDADE LINEAR"}
                </th>
                <th className="nivel-6">
                  {isEn ? "Level 1 – WASTE MANAGEMENT" : "Nível 1 – GESTÃO DE RESÍDUOS"}
                </th>
                <th className="nivel-6">
                  {isEn ? "Level 2 - CIRCULAR ECONOMY" : "Nível 2 - ECONOMIA CIRCULAR"}
                </th>
                <th className="nivel-6">
                  {isEn ? "Level 3 – CIRCULAR AND SUSTAINABLE CITY" : "Nível 3 – CIDADE CIRCULAR E SUSTENTÁVEL"}
                </th>
              </tr>
            </thead>
            <tbody>
              {activeData.map((row, index) => {
                const classesCores = ["nivel-0", "nivel-1", "nivel-2", "nivel-3", "nivel-4", "nivel-5"];
                const corDaLinha = classesCores[index] || "";

                return (
                  <tr key={index}>
                    <td className={`font-bold ${corDaLinha}`}>{row.categoria}</td>
                    <td className={corDaLinha}>{row.n0}</td>
                    <td className={corDaLinha}>{row.n1}</td>
                    <td className={corDaLinha}>{row.n2}</td>
                    <td className={corDaLinha}>{row.n3}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      <div className="text-container-cases">
          <p>{t('comp1-text-6')}</p>
      </div>

      {/* <div className="button-container">
        <Link to="/component1" className="button-cp1">
          {isEn ? "Proceed to the Questionnaire" : "Seguir para o Questionário"}
        </Link>
      </div> */}
      <div className="button-container">
      <Link to={isAuthenticated ? "/component1" : "/login"} className="button-cp1">
        {isEn ? "Proceed to the Questionnaire" : "Seguir para o Questionário"}
      </Link>
    </div>
    
      <div className="text-container-cases">
          <p>{t('comp1-text-7')}<a href={i18n.language === 'en'
    ? "/Comp1-English.xlsx" 
    : "/Comp1.xlsx"
  }
  download
  target="_blank" 
  rel="noopener noreferrer"
>
  link
</a></p>
      </div>
    </>
  );
};

export default Exemplo;